import { createTheme } from '@mui/material';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1B5CB4',
      light: '#000',
      contrastText: '#fff',
    },
    secondary: {
      main: '#00DEA8',
    },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    text: {
      primary: '#000',
      secondary: '#fff',
    },
    success: {
      main: '#00BB72',
    },
    error: {
      main: '#D73B56',
    },
    warning: {
      main: '#ECDAB6',
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1B5CB4',
      light: '#fff',
      contrastText: '#000',
    },
    secondary: {
      main: '#00DEA8',
    },
    background: {
      default: '#000',
      paper: '#000',
    },
    text: {
      primary: '#fff',
      secondary: '#fff',
    },
    success: {
      main: '#00BB72',
    },
    error: {
      main: '#D73B56',
    },
    warning: {
      main: '#ECDAB6',
    },
  },
});
